import { __exports as p } from "./index119.js";
import { __require as x } from "./index115.js";
import { __require as _ } from "./index85.js";
import { __require as m } from "./index88.js";
import { __require as l } from "./index117.js";
import { __require as v } from "./index112.js";
var c;
function w() {
  if (c) return p;
  c = 1;
  var s = p && p.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(p, "__esModule", { value: !0 }), p.Track = void 0;
  var d = s(x()), o = _(), h = m(), y = s(l()), u = s(v());
  function n(r, t) {
    o.Facade.call(this, r, t);
  }
  p.Track = n, d.default(n, o.Facade);
  var e = n.prototype;
  e.action = function() {
    return "track";
  }, e.type = e.action, e.event = o.Facade.field("event"), e.value = o.Facade.proxy("properties.value"), e.category = o.Facade.proxy("properties.category"), e.id = o.Facade.proxy("properties.id"), e.productId = function() {
    return this.proxy("properties.product_id") || this.proxy("properties.productId");
  }, e.promotionId = function() {
    return this.proxy("properties.promotion_id") || this.proxy("properties.promotionId");
  }, e.cartId = function() {
    return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
  }, e.checkoutId = function() {
    return this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId");
  }, e.paymentId = function() {
    return this.proxy("properties.payment_id") || this.proxy("properties.paymentId");
  }, e.couponId = function() {
    return this.proxy("properties.coupon_id") || this.proxy("properties.couponId");
  }, e.wishlistId = function() {
    return this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId");
  }, e.reviewId = function() {
    return this.proxy("properties.review_id") || this.proxy("properties.reviewId");
  }, e.orderId = function() {
    return this.proxy("properties.id") || this.proxy("properties.order_id") || this.proxy("properties.orderId");
  }, e.sku = o.Facade.proxy("properties.sku"), e.tax = o.Facade.proxy("properties.tax"), e.name = o.Facade.proxy("properties.name"), e.price = o.Facade.proxy("properties.price"), e.total = o.Facade.proxy("properties.total"), e.repeat = o.Facade.proxy("properties.repeat"), e.coupon = o.Facade.proxy("properties.coupon"), e.shipping = o.Facade.proxy("properties.shipping"), e.discount = o.Facade.proxy("properties.discount"), e.shippingMethod = function() {
    return this.proxy("properties.shipping_method") || this.proxy("properties.shippingMethod");
  }, e.paymentMethod = function() {
    return this.proxy("properties.payment_method") || this.proxy("properties.paymentMethod");
  }, e.description = o.Facade.proxy("properties.description"), e.plan = o.Facade.proxy("properties.plan"), e.subtotal = function() {
    var r = u.default(this.properties(), "subtotal"), t = this.total() || this.revenue();
    if (r)
      return r;
    if (!t)
      return 0;
    if (this.total()) {
      var i = this.tax();
      i && (t -= i), i = this.shipping(), i && (t -= i), i = this.discount(), i && (t += i);
    }
    return t;
  }, e.products = function() {
    var r = this.properties(), t = u.default(r, "products");
    return Array.isArray(t) ? t.filter(function(i) {
      return i !== null;
    }) : [];
  }, e.quantity = function() {
    var r = this.obj.properties || {};
    return r.quantity || 1;
  }, e.currency = function() {
    var r = this.obj.properties || {};
    return r.currency || "USD";
  }, e.referrer = function() {
    return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
  }, e.query = o.Facade.proxy("options.query"), e.properties = function(r) {
    var t = this.field("properties") || {};
    r = r || {};
    for (var i in r)
      if (Object.prototype.hasOwnProperty.call(r, i)) {
        var a = this[i] == null ? this.proxy("properties." + i) : this[i]();
        if (a == null)
          continue;
        t[r[i]] = a, delete t[i];
      }
    return t;
  }, e.username = function() {
    return this.proxy("traits.username") || this.proxy("properties.username") || this.userId() || this.sessionId();
  }, e.email = function() {
    var r = this.proxy("traits.email") || this.proxy("properties.email") || this.proxy("options.traits.email");
    if (r)
      return r;
    var t = this.userId();
    if (y.default(t))
      return t;
  }, e.revenue = function() {
    var r = this.proxy("properties.revenue"), t = this.event(), i = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
    return !r && t && t.match(i) && (r = this.proxy("properties.total")), f(r);
  }, e.cents = function() {
    var r = this.revenue();
    return typeof r != "number" ? this.value() || 0 : r * 100;
  }, e.identify = function() {
    var r = this.json();
    return r.traits = this.traits(), new h.Identify(r, this.opts);
  };
  function f(r) {
    if (r) {
      if (typeof r == "number")
        return r;
      if (typeof r == "string" && (r = r.replace(/\$/g, ""), r = parseFloat(r), !isNaN(r)))
        return r;
    }
  }
  return p;
}
export {
  w as __require
};
//# sourceMappingURL=index89.js.map
